var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"wait_act_wrap"},[_c('div',{staticClass:"top_line"},[_vm._v(" 仅用于平台实名认证，平台不会泄露您的信息，请放心认证。 ")]),_c('div',{staticClass:"content"},[_c('div',{staticClass:"cont_img"}),_c('div',{staticClass:"cont_down"},[_vm._v("等待信息审核")])])])
}]

export { render, staticRenderFns }